export function Skills() {
  return (
    <div className="page">
      <h1 className="section-title">技能市场选品</h1>
      <p className="lead" style={{ marginBottom: '2rem' }}>
        精选实用 Skills，剔除 ClawHub 上的恶意水件。安装前建议用 ClawDex 或审计 <code>SKILL.md</code> 代码。
      </p>

      <div className="card">
        <h2>常用精选</h2>
        <ul className="skill-list">
          <li><strong>GOG</strong> — 谷歌全家桶（搜索、Gmail 等）</li>
          <li><strong>Tavily Search</strong> — AI 友好搜索引擎</li>
          <li><strong>Summarize</strong> — 长文本总结</li>
          <li><strong>Composio</strong> — 集成 860+ 工具</li>
          <li><strong>Playwright</strong> — 浏览器自动化</li>
          <li><strong>AgentMail</strong> — 独立邮箱</li>
          <li><strong>Obsidian Direct</strong> — 连接本地知识库</li>
          <li><strong>Firecrawl MCP</strong> — 全网深度抓取与结构化</li>
          <li><strong>Exa Search</strong> — 开发者专用搜索</li>
          <li><strong>Home Assistant CLI</strong> — 智能家居控制</li>
        </ul>
      </div>

      <div className="card">
        <h2>安全提示</h2>
        <p>ClawHub 上存在恶意 Skill（如窃取密码或植入后门）。安装前请使用 ClawDex 查看评价，或自行审计 <code>SKILL.md</code> 源码。社区「黑红榜」可参考其他玩家的安全测评。</p>
      </div>
    </div>
  )
}
